import { useQuery } from "react-query";
import {
  getMalnutritionRiskAssessment,
  getPatientWeights,
} from "./malnutrition-endpoints";

import type { UseQueryResult } from "react-query";
import type {
  MalnutritionRiskAssessment,
  PatientWeightHistory,
} from "../types/Malnutrition";

export const useMalnutritionRiskQuery = (
  emrPatientID: string
): UseQueryResult<MalnutritionRiskAssessment, Error> =>
  useQuery<MalnutritionRiskAssessment, Error>(
    ["malnutritionrisk", emrPatientID],
    () => getMalnutritionRiskAssessment(emrPatientID),
    { enabled: !!emrPatientID }
  );

export const usePatientWeightsQuery = (
  emrPatientID: string
): UseQueryResult<PatientWeightHistory, Error> =>
  useQuery<PatientWeightHistory, Error>(
    ["patientweights", emrPatientID],
    () => getPatientWeights(emrPatientID),
    { enabled: !!emrPatientID }
  );
